import { z } from "zod";

export const getFulfillmentOrdersByOrder = {
  input: z.object({ orderId: z.string() }),
  output: z.any(),
};
